import { Button, Paper, Stack, TextField, Typography } from "@mui/material";
import ProgressWithDraggableDot from "./progressWithDraggableDot";

function removeLeadingZeroes(value) {
  if (typeof value !== "string") return value;

  return (
    value
      // Preserve sign separately
      .replace(/^(-?)(0+)(\d)/, "$1$3")
      // Handle cases like "000.5" → "0.5"
      .replace(/^(-?)0+\./, "$10.")
  );
}

export default function ProgressForm({
  row,
  i,
  value,
  onChange,
  input,
  onSubmit,
  onCancel,
  open,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        transform: open ? "scale(1.25)" : undefined,
        position: open ? "absolute" : undefined,
        top: open ? "40%" : undefined,
        right: open ? "43%" : undefined,
        p: 1.5,
        m: 0.5,
        borderRadius: 2,
        border: (t) => `1px solid ${t.palette.divider}`,
        bgcolor: (t) =>
          t.palette.mode === "light"
            ? t.palette.grey[100]
            : t.palette.grey[900],
        width: 300,
        pointerEvents: i !== 0 ? "none" : "auto",
        opacity: i !== 0 ? 0.6 : 1,
        zIndex: (t) => t.zIndex.modal + 1,
      }}
    >
      <Typography sx={{ fontSize: 18, pb: 4 }}>
        Progress in {row.month} {row.year}
      </Typography>
      {/* <Typography sx={{ pb: 4, fontSize: 14, textAlign: "end", pr: 3 }}>
        {fmtUtc(row.start)} - {fmtUtc(row.end)}
      </Typography> */}

      <ProgressWithDraggableDot
        value={i !== 0 ? row.min_total_progress : value}
        lastValue={row.min_total_progress}
        onChange={onChange}
        disabled={i !== 0}
      ></ProgressWithDraggableDot>
      <Stack direction="row" sx={{ py: 3 }}>
        <Typography
          sx={{
            alignContent: "center",
            pr: 1,
          }}
        >
          Last Month Progress
        </Typography>
        <TextField
          type="decimal"
          value={i !== 0 ? 0 : input}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            const val = e.target.value;
            if (
              val !== "" &&
              !/^-?(?:\d+([.,]\d{0,2})?|[.,]\d{1,2})$/.test(val)
            ) {
              return null;
            }

            onChange(removeLeadingZeroes(val));
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
          }}
          inputProps={{
            style: { textAlign: "right" },
          }}
          InputProps={{
            endAdornment: <>%</>,
          }}
          sx={{
            width: "30%",
            // Hide the arrows in Chrome, Safari, Edge, Opera
            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
              {
                display: "none",
              },
            // Hide arrows in Firefox
            "& input[type=number]": {
              MozAppearance: "textfield",
            },
          }}
        ></TextField>
      </Stack>
      <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <Button variant="contained" color="primary" onClick={() => onSubmit()}>
          Confirm
        </Button>
        {open && (
          <Button variant="outlined" color="primary" onClick={() => onCancel()}>
            Cancel
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
